let arrival_data1 = [
    {
        id : 0,
        imgurl : '/img/newarrival/section3_women1.jpg',
        brand : 'DAKS LADIES',
        title : '[인기 재입고/D-TRAVEL] 블루 단색 5부소매셔츠',
        persent : '20%',
        price : '255,000',
        saleprice : '202,760',
    },
    {
        id : 1,
        imgurl : '/img/newarrival/section3_women2.jpg',
        brand : 'HAZZYS LADIES',
        title : '블루 스트라이프 면혼방 반팔티셔츠',
        persent : '14%',
        price : '219,000',
        saleprice : '187,240',
    },
    {
        id : 2,
        imgurl : '/img/newarrival/section3_women3.jpg',
        brand : 'ATHE VANESSABRUNO WOMEN',
        title : '아이보리 턱장식 플레어 스커트',
        persent : '30%',
        price : '358,000',
        saleprice : '202,760',
    },
    {
        id : 3,
        imgurl : '/img/newarrival/section3_women4.jpg',
        brand : 'LANG&LU',
        title : 'MAXI SHIRRING JERSEY DRESS(맥시 셔링)_02',
        persent : '19%',
        price : '189,000',
        saleprice : '66,820',
    },
]

export default arrival_data1